var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.879 10.686 10.807 9 7.879 7.314z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.702 0H1.298C.581 0 0 .581 0 1.298v15.404C0 17.419.581 18 1.298 18h15.404c.717 0 1.298-.581 1.298-1.298V1.298C18 .581 17.419 0 16.702 0m-2.078 9.01s0 1.824-.232 2.705a1.41 1.41 0 0 1-.991.99c-.88.232-4.401.232-4.401.232s-3.511 0-4.4-.24a1.41 1.41 0 0 1-.992-.992C3.376 10.835 3.376 9 3.376 9s0-1.825.232-2.705c.13-.482.519-.871.991-1C5.48 5.062 9 5.062 9 5.062s3.52 0 4.4.24c.482.13.862.51.992.992.241.88.232 2.714.232 2.714"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export { SvgYoutube as ReactComponent };
export default "/_next/static/chunks/svg/youtube-19d05975a19b502e50d619a37d27efc0.svg";